import Theme from './theme/theme';
import {theme} from './reducers/index';
import * as actionTheme from './actions/index'
export {
    Theme,

    theme,
    actionTheme
};

